<app-testing></app-testing>

<app-shell
    *ngIf="((authenticated===true&&customerLoaded===true) || (authenticated===false&&customerLoaded===false)) && authenticationLoaded===true">
</app-shell>